import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faBootstrap,
  faCss3,
  faFigma,
  faGit,
  faGithub,
  faHtml5,
  faJava,
  faJs,
  faNodeJs,
  faPython,
  faReact
} from '@fortawesome/free-brands-svg-icons';
import './carosel.css';
import portfolioData from '../../portfolio.json';

const TechStackCarousel = () => {
  const { carousel } = portfolioData;

  const getIcon = (iconName) => {
    switch (iconName) {
      case 'faPython': return faPython;
      case 'faJava': return faJava;
      case 'faHtml5': return faHtml5;
      case 'faCss3': return faCss3;
      case 'faJs': return faJs;
      case 'faReact': return faReact;
      case 'faBootstrap': return faBootstrap;
      case 'faGit': return faGit;
      case 'faGithub': return faGithub;
      case 'faNodeJs': return faNodeJs;
      case 'faFigma': return faFigma;
      default: return faGithub;
    }
  }

  return (
    <section className="carousel-section">
      <div className="carousel-container">
        <h2 className="carousel-title">
          {carousel.title}
        </h2>

        <div className="scroll-container">
          <div className="gradient-left" />
          <div className="gradient-right" />

          <div className="scroll-content">
            {[...Array(2)].map((_, groupIndex) => (
              <div key={groupIndex} className="icon-container">
                {carousel.items.map((item, index) => (
                  <div key={`${groupIndex}-${index}`} className="icon-item">
                    <FontAwesomeIcon
                      icon={getIcon(item.icon)}
                      className="tech-icon"
                    />
                    <span className="icon-label">
                      {item.name}
                    </span>
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TechStackCarousel;